/* eslint-disable react-refresh/only-export-components */
import { cva, type VariantProps } from "class-variance-authority"
import { Slot } from "radix-ui"
import type { ComponentProps } from "react"

import { cn } from "cn"

const bodyVariants = cva("text-labels-primary", {
  variants: {
    size: {
      // 14/20px – Tailwinds `text-sm` trifft die Figma-Werte exakt.
      md: "text-sm",
      // 12/16px – Tailwinds `text-xs` trifft die Figma-Werte exakt.
      sm: "text-xs",
    },
    weight: {
      regular: "font-normal",
      semibold: "font-semibold",
      bold: "font-bold",
    },
  },
  defaultVariants: {
    size: "md",
    weight: "regular",
  },
})

export type BodySize = NonNullable<VariantProps<typeof bodyVariants>["size"]>

export type BodyWeight = NonNullable<
  VariantProps<typeof bodyVariants>["weight"]
>

export type BodyProps = ComponentProps<"p"> &
  VariantProps<typeof bodyVariants> & {
    asChild?: boolean
  }

function Body({
  className,
  size = "md",
  weight = "regular",
  asChild = false,
  ...props
}: BodyProps) {
  const Comp = asChild ? Slot.Root : "p"

  return (
    <Comp
      data-slot="body"
      data-size={size}
      data-weight={weight}
      className={cn(bodyVariants({ size, weight, className }))}
      {...props}
    />
  )
}

export { Body, bodyVariants }
